import styled from '@emotion/styled';
import { BaseContainer } from '../BaseContainer';

export const Wrapper = styled(BaseContainer)`
  width: 100vw;
  align-items: center;
  justify-content: center;
`;
